import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Skip interception for Matrix API requests
  if (req.url.includes('/_matrix/')) {
    return next(req);
  }

  console.log("request.url " + req.url);
  const isApiUrl = req.url.startsWith(environment.apiURL);
  console.log("isApiUrl " + isApiUrl);

  if (isApiUrl) {
    const currentUser = authService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token;

    if (isLoggedIn) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
          idUsuario: `${currentUser.id}`,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true'
        }
      });
    }
  }

  return next(req).pipe(
    tap({
      next: () => {},
      error: (err) => {
        if (err.status === 401) {
          const currentUser = authService.currentUserValue;
          const isLoggedIn = currentUser && currentUser.token;
          if (isLoggedIn && isApiUrl) {
            authService.logout();
          }
        }
      }
    })
  );
};
